<template>

  <div id="covid-data">

    

    <div class="row justify-content-center">

      
      <div class="col-12 col-lg-12 col-xl-6 mb-3 mb-xl-0">
        <div class="card">
          <div class="card-body">
            <h4 class="mb-2">Arizona Total Confirmed:</h4>
            <h2 class="mb-0" v-if="current.positive">{{current.positive.toLocaleString()}} 
              <span class="circled float-right" v-if="yesterday">
                <div v-if="(current.positive - yesterday.positive) == 0">
                  {{(current.positive - yesterday.positive).toLocaleString()}}
                </div>
                <div v-else>
                {{(current.positive - yesterday.positive) > 0 ? '+':'-'}}
                {{(current.positive - yesterday.positive).toLocaleString()}}
                </div>
               
                <small class="d-block">Change from previous day.</small>
              </span>
 </h2>
            
          </div>
        </div>
      </div>

  
      <div class="col-12 col-lg-12 col-xl-6 mb-3 mb-xl-0">
        <div class="card">
          <div class="card-body">
            <h4 class="mb-2">Arizona Total Deaths:</h4>
            <h2 class="mb-0" v-if="current.death">
              {{current.death.toLocaleString()}} 

               


              <span class="circled float-right" v-if="yesterday">

                <div v-if="(current.death - yesterday.death) == 0">
                  {{(current.death - yesterday.death).toLocaleString()}}
                </div>
                <div v-else>
                  {{(current.death - yesterday.death) > 0 ? '+':'-'}}{{(current.death - yesterday.death).toLocaleString()}}
                </div>

               
                
                <small class="d-block">Change from previous day.</small></span>
</h2>
          </div>
        </div>
      </div>

      <div class="col-12 mb-2 mt-3" v-if="has_chart=='true'">
        <div class="card">
          <div class="card-body">
             <h4 class="mb-3">New Cases</h4>

             <covid-chart
              v-if="chart"
              :chartdata="chart" 
              :options="chart_options"/>
            
          </div>
        </div>
      </div>

      

      <div class="col-12 date mt-1" v-if="date">
        Updated: {{date.format('MMMM Do YYYY')}}
      </div>
      
    </div>

  </div>

</template>

<script>
  import covid from './covid'
  export default covid
</script>

<style lang="css" scoped>

.circled{
  color: #d40000;
  font-size: 30px;
  line-height: 1em;
  text-align: right;
  
}

.circled small{
  font-size: 10px;
  line-height: 1em;
  margin-bottom: 0px;
  margin-top: 5px;
  color:#000
}

#covid-data{
  margin-bottom: 0px;
}
.date{
  font-size: 12px;
  line-height: 12px;
  font-family: bree, sans-serif;
  font-weight: 400;
  font-style: italic;
}

h3{
  text-align: left;
  
}

h2{
  font-size: 35px;
  line-height: 35px;
  color: #005cb9;
}



h4{
  font-size: 13px;
  line-height: 13px;
  font-family: bree, sans-serif;
  font-weight: 700;
  font-style: italic;
  text-transform: uppercase;
}
</style>

